// extracted by mini-css-extract-plugin
export var printerCard = "_av-1";
export var printerCardConfigured = "_av-2";
export var printerCardError = "_av-3";
export var printerCardsContainer = "_av-0";
export var printerIcon = "_av-8";
export var printerIconConfigured = "_av-5";
export var printerIconContainer = "_av-4";
export var printerIconError = "_av-6";
export var printerIconUnconfigured = "_av-7";